const langtrans={
      fhssyy:["返回上一页","Back"],
      czkkbb:["查看并操作","Check and operate"],
      cxxsxx:["出险信息","Time of claim"],
      ajjz:["案件进展","en_translated"],
      jyffwq:["救援服务清单","Service list"],
      qjtjjd:["其他节点：","Other nodes："],
      cczzzs:["操作说明：","specification of operation："],
      xxgdcs:["相关单据：","relevant documents："],
      xzz:["下载","Download"],
      jybjjj:["救援报价","Operation quotation"],
      bjjj:["、报价","、quotation"],
      ztbtbj:["整体报价","Total"],
      jyfy:["救援费用","Operation fee"],
      ajfy:["案件费用","Case fee"],
      ylfy:["医疗费用","Medical cost"],
      sjfy:["、实际费用","、Actual cost"],
      qjtfy:["其他费用","Other cost"],
      fybz:["费用备注：","Fee note："],
}
export default langtrans;


// WEBPACK FOOTER //
// ./src/components/fac/js/finishpar.vue.trans.js